import { Title, Texts, Media, Button } from "../Object";
import { Space } from "../Layout";
import { Scroll } from "../Animation";

const About = (props) => {
  return (
    <>
      <div className="l-row">
        <div className="p-box__wrap--about">
          <Space size={['197px', '64px']} />
            <div className="p-title__wrap--dot">
              <Scroll>
                <Texts slug="dot/about" class="c-text--en c-text--main"></Texts>
              </Scroll>
            </div>
            <Space size={['40px 0 64px', '24px 0 40px']}>
              <Scroll>
                <Texts slug="about/title"></Texts>
              </Scroll>
            </Space>
            <Scroll>
            <Texts slug="about/body"></Texts>
            </Scroll>

            <Space size={['64px 0 0', '48px 0 0']}>
              <Button link="/company/" type="end" slug="about"></Button>
            </Space>
          <Space size={['160px', '160px']} />
        </div>
      </div>
    </>
  );
};

export default About;
